
import { Carousel } from 'antd';

import './style.scss';

const SPEED = 1000;
const AUTOPLAY_SPEED = 4000;
const SLIDES_TO_SHOW = 1;
const SLIDES_TO_SCROLL = 1;

const propsCarousel = {
  dots: true,
  infinite: true,
  arrows: false,
  speed: SPEED,
  slidesToShow: SLIDES_TO_SHOW,
  slidesToScroll: SLIDES_TO_SCROLL,
  autoplay: true,
  autoplaySpeed: AUTOPLAY_SPEED,
  initialSlide: 6,
};

// Array of hotel brand images
const hotelBrands = [
  {
    src: "https://hutchapps.com/ashevilleplay/img/hotels/LOGO-Hilton-Garden-Inn-Asheville-Downtown-Asheville-Hotels-LOGO-450-x-125-px-2.png",
    alt: "Hilton Garden Inn Asheville Downtown"
  },
  {
    src: "https://hutchapps.com/ashevilleplay/img/hotels/LOGO-Holiday-Inn-Asheville-East-%E2%80%93-Blue-Ridge-Pkwy-Asheville-Hotels-LOGO-450-x-125-px.png",
    alt: "Holiday Inn Asheville East - Blue Ridge Pkwy"
  },
  {
    src: "https://hutchapps.com/ashevilleplay/img/hotels/LOGO-Kimpton-Hotel-Arras-by-Sheraton-Asheville-Hotels-LOGO-.png",
    alt: "Kimpton Hotel Arras by Sheraton"
  },
  {
    src: "https://hutchapps.com/ashevilleplay/img/hotels/LOGO-The-Omni-Grove-Park-Inn-Asheville-Hotels-LOGO-450-x-125-px.png",
    alt: "The Omni Grove Park Inn"
  },
  {
    src: "https://hutchapps.com/ashevilleplay/img/hotels/LOGO-The-Restoration-Asheville-Asheville-Hotels-LOGO-.png",
    alt: "The Restoration Asheville"
  },
  {
    src: "https://hutchapps.com/ashevilleplay/img/hotels/LOGO-The-Windsor-Boutique-Hotel-Asheville-Hotels-LOGO-450-x-125-px-2.png",
    alt: "The Windsor Boutique Hotel"
  },
  {
    src: "https://hutchapps.com/ashevilleplay/img/hotels/LOGO-Blind-Tiger-Hotel-Asheville-Hotels-LOGO-450-x-125-px-1.png",
    alt: "Blind Tiger Hotel"
  },
  {
    src: "https://hutchapps.com/ashevilleplay/img/hotels/LOGO-Crowne-Plaza-Resort-Asheville-Hotels-LOGO-450-x-125-px.png",
    alt: "Crowne Plaza Resort Asheville"
  },
  {
    src: "https://hutchapps.com/ashevilleplay/img/hotels/LOGO-Four-Points-by-Sheraton-Asheville-Hotels-LOGO-.png",
    alt: "Four Points by Sheraton"
  },
  {
    src: "https://hutchapps.com/ashevilleplay/img/hotels/LOGO-Grand-Bohemian-Lodge-Asheville-Hotels-LOGO-.png",
    alt: "Grand Bohemian Lodge"
  },
  {
    src: "https://hutchapps.com/ashevilleplay/img/hotels/LOGO-Haywood-Park-Hotel-Asheville-Hotels-LOGO-450-x-125-px.png",
    alt: "Haywood Park Hotel"
  }
];

export function SearchAshevillePlayTrustedBrands() {

  return (
    <div className="search-asheville-play-trusted-brands">
      <div className="main_title_2">
        <span><em></em></span>
        <h2>Asheville's Trusted Hotel Brands</h2>
        <p>We've partnered with the most popular hotels in the Asheville area</p>
      </div>

      <Carousel {...propsCarousel}>
        {hotelBrands.map((brand, index) => (
          <div key={index} className="trusted-brands-carousel-item">
            <img src={brand.src} alt={brand.alt} />
          </div>
        ))}
      </Carousel>
    </div>
  );
}

